var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getLocalStorage, LS_AUTH, clearAuthStorage } from '@/utils/storage';
export const AUTH = 'auth';
export const LOGIN = `login`;
export const LOGOUT = `logout`;
export const USER = 'user';
export const USERS = 'users';
export const TEAM = 'team';
export const TEAMS = 'teams';
export const USER_PROFILE = `user_profile`;
export const REFRESH = `refresh`;
export const REGISTER = `register`;
export const CHECK_TYPE = `check_type`;
export const DEVICES = 'devices';
export const DEVICE = 'device';
export const CLIENTE = 'client';
export const CLIENTI = 'clients';
export const ADDRESS = 'address';
export const ASSISTENZE = 'assistances';
export const ASSISTENZA = 'assistance';
export const SEARCH = 'search';
export const DASHBOARD = 'dashboard';
export const DASHBOARD_TEAM = 'dashboardTeam';
export const DASHBOARD_LOW_HOURS = 'dashboardLowHours';
export const LOG = 'log';
export const LASTLOG = 'lastLog';
export const STORE_LOG = 'storeLog';
export const getBaseApi = (type = 'login', params = {}) => {
    const externalApi = [ADDRESS];
    const map = {
        [ADDRESS]: `https://nominatim.openstreetmap.org/reverse?lat=${params.lat}&lon=${params.lon}&format=json&extratags=0`,
        [USERS]: `${USERS}`,
        [USER]: `${USER}`,
        [TEAMS]: `${TEAMS}`,
        [TEAM]: `${TEAM}`,
        login: `${AUTH}/login`,
        logout: `${AUTH}/logout`,
        user_profile: `${AUTH}/user-profile`,
        refresh: `${AUTH}/refresh`,
        register: `${AUTH}/register`,
        check_type: `${AUTH}/check-type`,
        devices: `${DEVICES}`,
        device: `${DEVICE}`,
        clients: `${CLIENTI}`,
        client: `${CLIENTE}`,
        [SEARCH]: `${SEARCH}`,
        [ASSISTENZA]: `${ASSISTENZA}`,
        [ASSISTENZE]: `${ASSISTENZE}`,
        [LASTLOG]: `${LOG}/data`,
        [STORE_LOG]: `${LOG}/store`,
        [DASHBOARD]: `${DASHBOARD}/data`,
        [DASHBOARD_TEAM]: `${DASHBOARD}/teams`,
        [DASHBOARD_LOW_HOURS]: `${DASHBOARD}/low-hours`,
    };
    console.log('base API: ' + process.env.MIX_APP_PUBLIC_URL_API);
    return externalApi.includes(type) ?
        map[type] :
        process.env.MIX_APP_PUBLIC_URL_API + (map[type] || map['login']);
};
const getBearer = () => {
    const token = getLocalStorage(LS_AUTH);
    return token ? `Bearer ${token}` : undefined;
};
/**
 * Gestisce la risposta delle API, controllando in particolare se la sessione è scaduta.
 * In caso di sessione scaduta (status 'expired'), pulisce il localStorage e reindirizza al login.
 */
const handleResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield response.json();
    if (response.status === 401 && data && data.status === 'expired') {
        // Pulisce i dati di autenticazione in modo selettivo
        clearAuthStorage();
        // Reindirizza alla pagina di login solo se non siamo già lì, per evitare loop di ricaricamento
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return Promise.reject(new Error('session_expired'));
    }
    return data;
});
/*const fetchWrapper = (url: string, options: RequestInit, timeout: number): Promise<Response> => {
  return new Promise((resolve, reject) => {
    fetch(url, options).then(resolve, reject);

    if (timeout) {
      const e = new Error("Connection timed out");
      setTimeout(() => reject(e), timeout);
    }
  });
};*/
const fetchWrapper = (url, options, timeout) => {
    return new Promise((resolve, reject) => {
        let settled = false;
        const timer = timeout ? setTimeout(() => {
            if (!settled) {
                settled = true;
                reject(new Error("Connection timed out"));
            }
        }, timeout) : null;
        fetch(url, options).then((res) => {
            if (!settled) {
                settled = true;
                if (timer)
                    clearTimeout(timer);
                resolve(res);
            }
        }, (err) => {
            if (!settled) {
                settled = true;
                if (timer)
                    clearTimeout(timer);
                // Distingui timeout da rete assente
                reject(err);
            }
        });
    });
};
export function postData() {
    return __awaiter(this, arguments, void 0, function* (url = '', data = {}) {
        const bearer = getBearer();
        const headers = {
            'Content-Type': 'application/json',
            'X-API-Generator': 'fefoweb/GestioneInterventi',
            // 'Content-Type': 'application/x-www-form-urlencoded',
        };
        if (bearer) {
            headers['Authorization'] = bearer;
        }
        // Default options are marked with *
        const response = yield fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        });
        return handleResponse(response);
    });
}
export function postDataFile() {
    return __awaiter(this, arguments, void 0, function* (url = '', data = {}) {
        const bearer = getBearer();
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });
        const headers = {
            'X-API-Generator': 'fefoweb/GestioneInterventi',
            // 'Content-Type': 'application/x-www-form-urlencoded',
        };
        if (bearer) {
            headers['Authorization'] = bearer;
        }
        //---- https://stackoverflow.com/questions/47676134/laravel-request-all-is-empty-using-multipart-form-data + without Content-Type
        formData.append('_method', 'PUT'); //'Content-Type': 'multipart/form-data',
        // Default options are marked with *
        const response = yield fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: formData, // body data type must match "Content-Type" header
        });
        return handleResponse(response);
    });
}
export function putData(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, data = {}, options = {}) {
        const bearer = getBearer();
        const headers = {
            'Content-Type': 'application/json',
            'X-API-Generator': 'fefoweb/GestioneInterventi',
            // 'Content-Type': 'application/x-www-form-urlencoded',
        };
        if (bearer) {
            headers['Authorization'] = bearer;
        }
        // Default options are marked with *
        const response = yield fetchWrapper(url, {
            method: 'PUT', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data), // body data type must match "Content-Type" header
        }, ((options === null || options === void 0 ? void 0 : options.timeout) || 15000));
        return handleResponse(response);
    });
}
/*export async function putDataFile(url = '', data = {}) {
  const bearer = getBearer();
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  //---- https://stackoverflow.com/questions/47676134/laravel-request-all-is-empty-using-multipart-form-data + without Content-Type
  formData.append('_method', 'PUT'); //'Content-Type': 'multipart/form-data',
  // Default options are marked with //*
  const response = await fetch(url, {
    method: 'PUT', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      //'Content-Type': 'multipart/form-data',
      Authorization: bearer,
      'X-API-Generator': 'fefoweb/TechIntervention',
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: formData, // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}*/
export function getData() {
    return __awaiter(this, arguments, void 0, function* (url = '') {
        const bearer = getBearer();
        const headers = {
            'Content-Type': 'application/json',
            'X-API-Generator': 'fefoweb/GestioneInterventi',
            // 'Content-Type': 'application/x-www-form-urlencoded',
        };
        if (bearer) {
            headers['Authorization'] = bearer;
        }
        // Default options are marked with *
        const response = yield fetch(url, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });
        return handleResponse(response);
    });
}
export function deleteData() {
    return __awaiter(this, arguments, void 0, function* (url = '') {
        const bearer = getBearer();
        const headers = {
            'Content-Type': 'application/json',
            'X-API-Generator': 'fefoweb/GestioneInterventi',
            // 'Content-Type': 'application/x-www-form-urlencoded',
        };
        if (bearer) {
            headers['Authorization'] = bearer;
        }
        // Default options are marked with *
        const response = yield fetch(url, {
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers,
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });
        return handleResponse(response);
    });
}
